import { Avatar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormSelect } from '../../../components/Forms/FormSelect';
import { ProfilePicture } from '../../../components/User/ProfilePicture';
import { UserRoleSelect } from '../../../components/User/UserRoleSelect';
import { Me } from '../../../redux/Auth/auth.selectors';
import { getInitials } from '../../../services/Utils';
import { HorizontalStack, SmartContainer, Stack, Surface } from '../../../styles/Containers';
import { StyledAreYouSureButton, StyledDangerButton, StyledButton } from '../../../styles/matieralui/Button';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { StyledPopover } from '../../../styles/matieralui/Popover';
import { StyledP } from '../../../styles/StyledHTML';
import { IconRemove } from '../../Icons';
import { deletePermission, updatePermission } from './redux/permissions.actions';
export const PermissionUser = ({ user, title = null }) => {

    const dispatch = useDispatch();
    const me = Me();
    const isMe = (user?.id === me.id) ? true : false;

    const [role, setRole] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [removeCheck, setRemoveCheck] = useState(false);


    useEffect(() => {
        if (user?.role) setRole(user.role);
        else setRole(null);
    }, [user]);

    const disabledRole = (user?.role === 'admin' || user?.role === 'owner');
    const showRole = (!isMe && !disabledRole) ? true : false;


    const handleDelete = () => {

        dispatch(deletePermission(user.permissionId));
        setRemoveCheck(false);
    }

    const handleDeleteClick = (e) => {
        // Show the Popover
        setRemoveCheck(true);

        // Anchor it to the currently item
        setAnchorEl(e.currentTarget)

    }
    const closePopover = () => {
        setAnchorEl(null)
        setRemoveCheck(false);
    }


    const handleRoleChange = (role) => {
        setRole(role)
        dispatch(updatePermission(user.permissionId, { role }))
    }

    return (
        <Surface flex align="center" justify="space-between">
            {!title && (
                <HorizontalStack flex align="center">
                    <ProfilePicture user={user} />
                    <StyledP small>{user?.firstName + ' ' + user?.lastName}</StyledP>
                </HorizontalStack>
            )}
            {title && (<StyledP>{title}</StyledP>)}
            <HorizontalStack flex align="center">
                {showRole === true && (
                    <FormSelect label="Access" value={role} onChange={handleRoleChange}>
                        <option key="viewer" value="viewer">Viewer</option>
                        <option key="editor" value="editor">Collaborator</option>
                    </FormSelect>
                )}
                {showRole === false && (<StyledP light small>{role}</StyledP>)}
                {!isMe && !disabledRole && (
                    <StyledIconButton onClick={handleDeleteClick}><IconRemove /></StyledIconButton>
                )}
            </HorizontalStack>
            <StyledPopover open={removeCheck} anchorEl={anchorEl} onClose={() => closePopover()}>
                <Stack>
                    <StyledP>Are you sure want?</StyledP>
                    <HorizontalStack flex justify="flex-end">
                        <StyledButton onClick={closePopover}>Cancel</StyledButton>
                        <StyledDangerButton variant="contained" onClick={() => handleDelete()}>Remove</StyledDangerButton>
                    </HorizontalStack>
                </Stack>
            </StyledPopover>

        </Surface>
    )
}